module.exports = __webpack_public_path__ + "img/load-smart.4f4b7ea1.svg";